import styled, { css } from 'styled-components';

import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';

interface SaveContainerProps {
    $morePadding?: boolean;
}

interface FavoritesContainerProps {
    $isLiveCard?: boolean;
    $isMobile?: boolean;
}

export const StyledFavoriteContainer = styled.section<FavoritesContainerProps>`
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
    max-height: 30px;
    ${({ $isLiveCard, $isMobile }) => {
        if ($isLiveCard && !$isMobile) {
            return css`
                right: 0px;
            `;
        }
    }}
`;

export const StyledItemSaveContainer = styled(ItemSaveContainer)<SaveContainerProps>`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    padding: 5px;
    ${({ $morePadding }) =>
        $morePadding &&
        `
            top: 20px;
            right: 20px;
        `}

    @media print {
        display: none;
    }
`;

interface PrintContainerProps {
    noWidthLimit?: boolean;
}

export const StyledPrintContainer = styled.div<PrintContainerProps>`
    position: relative;
    ${({ noWidthLimit }) => (noWidthLimit ? 'width: fit-content;' : '')}

    @media print {
        display: flex;
        flex-direction: row;
    }
`;

export const TitleMenuWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;
